(function () {
  var body = document.body;
  var menu = document.querySelector('[data-mobile-menu]');
  var overlay = document.querySelector('[data-menu-overlay]');
  var toggle = document.querySelector('[data-menu-toggle]');
  var closeButton = document.querySelector('[data-menu-close]');

  function setMenu(open) {
    if (!menu || !overlay || !toggle) return;
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Fechar menu' : 'Abrir menu');
    overlay.hidden = !open;
    body.classList.toggle('menu-open', open);
    if (open) menu.querySelector('a').focus();
    else toggle.focus();
  }

  if (toggle) toggle.addEventListener('click', function () { setMenu(toggle.getAttribute('aria-expanded') !== 'true'); });
  if (closeButton) closeButton.addEventListener('click', function () { setMenu(false); });
  if (overlay) overlay.addEventListener('click', function () { setMenu(false); });
  if (menu) menu.addEventListener('click', function (event) { if (event.target.closest('a')) setMenu(false); });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && body.classList.contains('menu-open')) setMenu(false); });
})();
